import { FormControl, FormLabel, FormControlProps, FormLabelProps } from '@mui/material';
import { useField } from 'formik';
import { ReactNode } from 'react';

interface FormControlWithLabelProps extends FormControlProps {
    label: string;
    description?: ReactNode | string;
    children: ReactNode;
    labelProps?: FormLabelProps;
    descriptionProps?: FormLabelProps;
    htmlFor: string;
    variant?: 'standard' | 'outlined' | 'filled';
}

export default function FormControlWithLabel({
    label,
    description = '',
    children,
    htmlFor,
    labelProps = {},
    descriptionProps = {},
    sx,
    variant = 'standard',
    ...formControlProps
}: FormControlWithLabelProps) {
    const [, { error, touched }] = useField(htmlFor);

    return (
        <FormControl sx={{ mb: 5, ...sx }} error={touched && !!error} variant={variant} {...formControlProps} fullWidth>
            <FormLabel htmlFor={htmlFor} sx={{ mb: 1 }} {...labelProps}>
                {label}
            </FormLabel>
            <FormLabel {...descriptionProps}>{description}</FormLabel>
            {children}
        </FormControl>
    );
}
